/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {PriceIntervalVO} from './price-interval-vo.model';
import {AgentZoneVO} from './agent-zone-vo.model';
import {DeliveryServiceVoModel} from './delivery-service-vo.model';

export class TariffDTO extends JSONable {

  uuid: string | undefined = undefined;
  deliveryServiceVO: DeliveryServiceVoModel | undefined = undefined;
  tariffCalculationMethod: string | undefined = undefined;
  priceIntervalList: PriceIntervalVO[] = [];
  accountVO: string | undefined = undefined;
  startZone: AgentZoneVO | undefined = undefined;
  endZone: AgentZoneVO | undefined = undefined;
  /**
   * @deprecated use accountVO instead
   */
  contractVO: string | undefined = undefined;
}
